module.exports = __webpack_public_path__ + "static/media/sales_support_active.3e8a2975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/sales_support_active.svg
// module id = 1099
// module chunks = 36